<div
  class="bg-input-background box-border flex w-full text-base"
  [ngClass]="{
    'cursor-not-allowed opacity-60': ngControl.control!.disabled,
  }">
  @let hasError = ngControl.errors && ngControl.touched;
  <div class="relative w-full bg-inherit">
    <textarea
      [attr.data-testid]="id() | appendTestId: 'input'"
      [formControl]="ngControl.control! | toFormControl"
      [id]="id()"
      [placeholder]="label() ?? ''"
      type="text"
      class="border-input rounded-input peer p-input focus:border-input-focus text-standard-text w-full bg-transparent placeholder-transparent focus:ring-0"
      [ngClass]="{
        'border-input-error': hasError,
        'border-input-ring': !hasError,
        'pointer-events-none': ngControl.disabled,
      }"></textarea>
    <label
      [attr.data-testid]="id() | appendTestId: 'label'"
      class="peer-placeholder-shown:text-input-text peer-focus:text-input-focus pointer-events-none absolute -top-2 right-4 left-4 w-fit max-w-[calc(100%-2rem)] cursor-text overflow-hidden bg-inherit text-sm overflow-ellipsis whitespace-nowrap transition-all peer-placeholder-shown:top-3.5 peer-placeholder-shown:max-h-6 peer-placeholder-shown:bg-inherit peer-placeholder-shown:text-base peer-focus:-top-2 peer-focus:text-sm"
      [for]="id()"
      [ngClass]="{
        'text-input-error': hasError,
        'text-standard-text': !hasError,
      }">
      {{ formattedLabel() }}
    </label>
    @if (hasError && !errorTemplate()) {
      <aw-error-message [attr.data-testid]="id() | appendTestId: 'error'">
        <ng-content></ng-content>
      </aw-error-message>
    }
    @if (hasError && errorTemplate()) {
      <aw-error-message [attr.data-testid]="id() | appendTestId: 'error'">
        <ng-container *ngTemplateOutlet="errorTemplate()!"></ng-container>
      </aw-error-message>
    }
  </div>
</div>
